import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-default-text" }

import { ref } from 'vue';
import { useStore } from 'vuex';
import GenericPrompt from '@shell/dialog/GenericPrompt';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnsavedChangesDialog',
  props: {
    onProceed: { type: Function },
    onCancel: { type: Function }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const t = store.getters['i18n/t'];

const props = __props;

const emit = __emit;

const genericPrompt = ref<HTMLElement | null>(null);

const handleDiscard = async () => {
  if (props.onProceed) {
    props.onProceed();
  }
  emit('close');
};

const handleClose = () => {
  if (props.onCancel) {
    props.onCancel();
  }
  emit('close');
};

const config = {
  applyMode:   'discard',
  applyAction: handleDiscard,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GenericPrompt), _mergeProps({
    ref_key: "genericPrompt",
    ref: genericPrompt
  }, config, { onClose: handleClose }), {
    title: _withCtx(() => [
      _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(t)('epinio.unsavedChanges.title')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(t)('epinio.unsavedChanges.pageMessage')), 1)
    ]),
    _: 1,
    __: [0]
  }, 16))
}
}

})